const isWeekend = (date) => [6, 7].includes(date.isoWeekday())

export const availableRollingPeriodEnd = (startTime, rollingPeriod) => {
  let current = startTime
  let daysLeft = rollingPeriod

  while (daysLeft >= 1) {
    current = current.clone().add({ days: 1 })
    if (!isWeekend(current)) {
      daysLeft -= 1
    }
  }

  return current
}
